<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Workshifts</h3>
       </template>
          <nav class="row">
              <ol class="breadcrumb arr-right bg-breadcrum">
                <li class="breadcrumb-item">
                   <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/hr/employeelist">Active Employees</router-link>
                 </li>
                <li class="breadcrumb-item">
                   <router-link to="/hr/resigned">Inactive Employees</router-link>
                </li>
                <li class="breadcrumb-item">
                   <router-link to="/hr/dependents">Dependents</router-link>
                </li>
                <li class="breadcrumb-item active">Workshifts</li>
                <!-- NEW ADDITIONAL -->
                <li class="breadcrumb-item">
                   <router-link to="/hr/scheduleadjustment">Schedule Adjustment</router-link>
                </li>
                <li class="breadcrumb-item">
                   <router-link to="/hr/undertimerequest">Undertime Request</router-link>
                </li>
                <li class="breadcrumb-item">
                    <router-link to="/hr/nterequest">NTE Tracker</router-link>
                </li> 
                <li class="breadcrumb-item">
                    <router-link to="/hr/coaching/records">Employee Coached</router-link>
                  </li>
             </ol>
            </nav>
         <hr style="margin-top:-10px"/>
         <div class="row">  
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <button class="btn  btn-primary float-right" v-b-modal.add-new-item><i class="fa fa-plus"></i>Add Workshifts</button>
            </div> 
         </div>   
       <hr/>
       <div class="row">
            <div class="col-md-10">
               <p><i class="fa fa-search"></i> Search Employee</p>
               <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
            </div>
            <div class="col-md-1">
               <div class="form-group">
                  <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                  <select v-model="order_by" class="form-control" required>
                     <option value="">Default</option>
                     <option value="-1">ASC</option>
                     <option value="1">DESC</option>
                  </select>
               </div>
            </div>
            <div class="col-md-1">
               <div class="form-group">
                  <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                  <select v-model="page_limit" class="form-control" required>
                     <option value="">Default</option>
                     <option value="5">5</option>
                     <option value="10">10</option>
                     <option value="25">25</option>
                     <option value="50">50</option>
                     <option value="100">100</option>
                     <option value="500">500</option>
                  </select>
               </div>
            </div>
         </div>
         <hr>
         <!-- PAGINATION -->
         <b-pagination
            v-model="curentPage"
            :total-rows="items.length"
            :per-page="perPage"
            aria-controls="my-table"
            align="right"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            ></b-pagination>
         <!-- END PAGINATION -->
         <hr>
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                <tr>
                   <th>#</th>
                   <th>Employee Name</th>
                   <th>Sched Type</th>
                   <th><i class="fa fa-calendar"></i>Sched Time</th> 
                   <th>Status</th>
                   <th>Timezones</th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="item,index in computedEmployee">
                 <!-- <template v-if="item === 'no data found'">
                        <td colspan="100%"><h4>  <i class="fa fa-database"></i> Empty Records ...</h4></td>  
                     </template>  
                 <template v-else>   -->
                       <td>{{index + 1}}.</td>
                       <td> <b>{{item.full_name | capitalize }}</b> <br/><i>{{item.position_name}}</i></td>
                       <td>{{item.schedule | capitalize}}</td>
                       <td>{{item.time}}</td>
                       <td>{{item.status}}</td>
                       <td>{{item.timezone_name}}</td>
                       <td width="170">
                          <a href="#" @click="get_selected_id(item)" class="btn btn-xs btn-default" v-b-modal.update-schedule v-b-tooltip.hover title="click to update designation item and position name"><i class="fa fa-pencil"></i>Update</a>
                          <button  class="btn btn-xs" @click = "deleteItem(item.id, index)" v-b-tooltip.hover title="Delete Entry"><li class="fa fa-trash-o"></li>&nbsp;Delete</button>
                        </td>
                  <!-- </template>   -->
                </tr>
             </tbody>
          </table>
          <br/>
            <!-- PAGINATION NATIVE WAY -->
            <div class="row">
                    <div class="col-md-6">
                        <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                    </div>
                    <div class="col-md-6">
                      <b-pagination
                          v-model="curentPage"
                          :total-rows="items.length"
                          :per-page="perPage"
                          aria-controls="my-table"
                          align="right"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"
                      ></b-pagination>
                    </div>
                 </div>
                 <!-- END PAGINATION -->
                 <template v-if="display_indicator === 1">
                  <center>
                     <br/><br/>
                     <img  src="/static/img/warning.png"  width="225" height="190">
                     <h1>You've lost your network connection</h1>
                     <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
                     <br/><br/>
                  </center>
               </template>
            <!-- ADD NEW ITEM -->
            <b-modal id="add-new-item"  ref="add-new-item" size="l"   title="Register Workshifts"  hide-footer>
                <h3>Workshifts</h3>
                <div class="form-group">
                   <label>Employee Name:</label>
                   <select class="form-control" v-model="employee_id" v-bind:class="{ 'is-invalid': error_handler && error_handler.employee_id}">
                      <option value="" disabled>-- Select Employee --</option>
                      <option v-for="emp in employees" v-bind:value="emp.id">{{emp.full_name}}</option>
                   </select>
                   <span v-if="error_handler.employee_id" class="invalid-feedback">{{ error_handler.employee_id[0] }}</span>
                </div>
                <div class="form-group">
                   <label>Sched Type:</label>
                    <select v-model="selectedSched" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.schedule}">
                      <option value="">-- Select Schedule --</option>
                      <option v-for="(sched_obj, sched_index) in schedules" :value="sched_index">{{sched_index}}</option>
                   </select>
                   <span v-if="error_handler.schedule" class="invalid-feedback">{{ error_handler.schedule[0] }}</span>
                </div>
                <div class="form-group">
                    <label>Sched Time:</label>
                    <select :disabled="sched_items.length == 0" v-model="selectedTime" class="form-control" v-bind:class="{ 'is-invalid': error_handler && error_handler.time}">
                        <option value="">-- Select Time --</option>
                        <option v-for="(time_obj, time_index) in sched_items" :value="time_obj.time">{{time_obj.time}}</option>
                    </select>
                    <span v-if="error_handler.time" class="invalid-feedback">{{ error_handler.time[0] }}</span>
                 </div>
                  <div class="form-group">
                    <label>Timezone:</label>
                    <select 
                       v-model="timezoneId" 
                       v-bind:class="{ 'is-invalid': error_handler && error_handler.timezone_id}" 
                       class="form-control"
                       click="hide_message_timezone_id"
                       >
                       <option disabled value="">-- Please select one --</option>
                       <option v-for="time in timezoneItem" v-bind:value="time.id" v-text="time.timezone_name"></option>
                    </select>
                    <span v-if="error_handler.timezone_id" class="invalid-feedback">{{ error_handler.timezone_id[0] }}</span> 
                  </div>
                <div class="form-group">
                   <button class="btn btn-info float-right" @click="add_new_item"><i class="fa fa-save"></i> Submit form</button>
                </div>
             </b-modal>    
               <!-- MODAL FOR UPDATE RECORD  -->
               <b-modal id="update-schedule" ref="hide-update-sched"  size="l"   title="Update Item"  hide-footer>
                <h3>{{selected_employee.full_name | capitalize }}</h3>
                <div class="form-group">
                   <label>Sched Type:</label>
                   <select v-model="selectedSched" class="form-control">
                     <option value="">-- Select Schedule --</option>
                     <option v-for="(sched_obj, sched_index) in schedules" :value="sched_index">{{sched_index}}</option>
                  </select>
                </div>
                <div class="form-group">
                    <label>Sched Time:</label>
                    <select :disabled="sched_items.length == 0" v-model="selectedTime" class="form-control">
                        <option value="">-- Select Time --</option>
                        <option v-for="(time_obj, time_index) in sched_items" :value="time_obj.time">{{time_obj.time}}</option>
                    </select>
                 </div>
                 <div class="form-group">
                  <label>Timezone:</label>
                  <select 
                     v-model="timezoneId" 
                     v-bind:class="{ 'is-invalid': error_handler && error_handler.timezone_id}" 
                     class="form-control"
                     click="hide_message_timezone_id"
                     >
                     <option disabled value="">-- Please select one --</option>
                     <option v-for="time in timezoneItem" v-bind:value="time.id" v-text="time.timezone_name"></option>
                  </select>
                  <span v-if="error_handler.timezone_id" class="invalid-feedback">{{ error_handler.timezone_id[0] }}</span> 
                </div>
                <div class="form-group">
                   <button class="btn btn-info float-right" @click="update_schedule"><i class="fa fa-save"></i> Save Changes</button>
                </div>
             </b-modal>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   
       </div>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
import {mapState} from 'vuex'
export default {
  components: {
    Card,
  },

  data() {
    return {
      items: [],
      
      //FILTER
      search: "",
      order_by: "",
      page_limit: "",
      start_page: 1,
      sortAsc: true,
      //Indicator
      display_indicator: "",
      employees: [],
      loading: true,
      timezoneId:"",
      //------------------------
      schedules: {

        "Day-Shift": [{
            "time": "5AM - 2PM"
          },
          {
            "time": "6AM - 3PM"
          },
          {
            "time": "7AM - 4PM"
          },
          {
            "time": "8AM - 5PM"
          },
          {
            "time": "9AM - 6PM"
          },
          {
            "time": "10AM - 7PM"
          },
          {
            "time": "11AM - 8PM"
          },
          {
            "time": "12NN - 9PM"
          },
          {
            "time": "1PM - 10PM"
          },
          {
            "time": "2PM - 11PM"
          },
          {
            "time": "3PM - 12NN"
          },

        ],
        "Mid-Shift": [{
            "time": "11PM - 8AM"
          },
          {
            "time": "12NN - 9AM"
          },
          {
            "time": "1AM - 10AM"
          },
          {
            "time": "2AM - 11AM"
          },
          {
            "time": "3AM - 12NN"
          },
          {
            "time": "4AM - 1PM"
          }
        ],
        "Night-Shift": [{
            "time": "9PM - 6AM"
          },
          {
            "time": "10PM - 7AM"
          },
          {
            "time": "8PM - 5AM"
          },
          {
            "time": "7PM - 4AM"
          },
          {
            "time": "4PM - 1AM"
          },
          {
            "time": "5PM - 2AM"
          },
          {
            "time": "6PM - 3AM"
          }
        ]
      },
      sched_items: [],
      time_items: [],
      //input data
      employee_id: "",
      selectedSched: "",
      selectedTime: "",

      selected_employee: {},
      error_handler: [],
      //PAGINATION
      perPage: 100,
      curentPage: 1
    }
  },

  mounted: function () {
    this.get_work_shifts();
    this.get_list_of_employee_no_sched();
    this.$store.dispatch("GET_TIMEZONES")
  },

  methods: {
    get_selected_id(item){
         this.selected_employee = item
    },

    get_work_shifts() {
      axios.get('api/workshifts')
        .then(response => {
          this.items = response.data
          this.loading = false
          this.display_indicator = 2;
        })
        .catch(e => {
          console.log(e.response)
          this.display_indicator = 1;

        });
    },

    get_list_of_employee_no_sched() {
      axios.get('api/employeenosched')
        .then(response => {
          this.employees = response.data
        })
        .catch(e => {
          console.log(e.response)
        });
    },

    hide_errorHanler(){
      if (!!this.error_handler.timezone_id) this.error_handler.timezone_id = false
      if (!!this.error_handler.employee_id) this.error_handler.employee_id = false
      if (!!this.error_handler.schedule) this.error_handler.schedule = false
      if (!!this.error_handler.time) this.error_handler.time = false
    },

    add_new_item(e) {
      e.preventDefault();
      this.$swal({
          title: 'Are you sure?',
          text: 'Do you want to save',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: false,
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.post('api/workshifts/add', {
                employee_id: this.employee_id,
                schedule: this.selectedSched,
                time: this.selectedTime,
                timezone_id:this.timezoneId
              })
              .then(resp => {
                this.$swal('Save', 'You successfully save this file', 'success')
                this.get_work_shifts();
                this.get_list_of_employee_no_sched();
                this.$refs['add-new-item'].hide();
                this.employee_id = ""
                this.selectedSched = ""
                this.selectedTime = ""
                this.timezoneId = ""
                this.hide_errorHanler()

              })
              .catch(error => {
                if (error.response.status == 422) {
                  this.error_handler = error.response.data.errors
                }
                console.log('response => ', error);
              });
          }
        });
    },
    update_schedule() {
      axios.post('api/workshifts/update/' + this.selected_employee.id, {
          schedule: this.selectedSched,
          time: this.selectedTime,
          timezone_id:this.timezoneId
        })
        .then(response => {
          this.$swal({
            type: 'success',
            title: 'Save',
            text: 'You successfully save',
            showConfirmButton: false,
            timer: 2000
          })
          this.get_work_shifts();
          this.get_list_of_employee_no_sched();
          this.$refs['hide-update-sched'].hide();
          this.employee_id = ""
          this.selectedSched = ""
          this.selectedTime = ""
          this.timezoneId = ""
          this.hide_errorHanler()
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        });

    },
    deleteItem(id, index) {

      /* USING SWEET ALERT */

      this.$swal({
          title: 'Are you sure?',
          text: 'You can\'t revert your action',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes Delete it!',
          cancelButtonText: 'No, Keep it!',
          showCloseButton: false,
          showLoaderOnConfirm: true
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.delete('api/workshifts/delete/' + id)
              .then(response => {
                // this.items.splice(index, 1); //--> reloader 
                this.get_work_shifts();
                this.get_list_of_employee_no_sched();
                this.$swal('Deleted', 'You successfully deleted this file', 'success')
              })
              .catch(response => {
                //alert("error");
                console.log(response.response);
                this.$swal('Error Code', 'Review your code', 'error')
              });
          }
        });


    }
  },
  computed: {
    ...mapState([
        'timezoneItem'
      ]),

     hide_message_timezone_id() {
       if (!!this.error_handler.timezone_id) this.error_handler.timezone_id = false
     },

    // PAGINATION
    offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit() {
      return this.offset + this.page_limit;
    },
    total_item() {
      return this.items.length
    },
    computedEmployee() {
      let filtered = this.items
      // USE IN PAGINATION 
      let start = (this.curentPage - 1) * this.perPage
      let end = this.curentPage * this.perPage
      filtered = filtered.slice(start, end);
      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
          );
          return filtered
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
          return filtered
        }
      }
      return filtered
    }
  },


  watch: {
    selectedSched: function () {
      // Clear previously selected values
      this.sched_items = [];
      this.time_items = [];
      this.selectedTime = "";
      // Populate list of sched_items in the second dropdown
      if (this.selectedSched.length > 0) {
        this.sched_items = this.schedules[this.selectedSched]
      }

      console.log(this.sched_items)
    },
    selectedTime: function () {
      // Clear previously selected values
      this.time_items = [];
      // Now we have a continent and sched_index. Populate list of time_items in the third dropdown
      if (this.selectedTime.length > 0) {
        this.time_items = this.schedules[this.selectedSched][this.selectedTime]
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-work-shifts.vue